'use client';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';

import { useClientHasRendered } from '../../helpers/hooks';

import { URLParameters } from './constants/url/urlParameters';

const DynamicOnboarding = dynamic(async () => import('./Onboarding').then(mod => mod.Onboarding), {
  ssr: false,
});

export const OnboardingWrapper = () => {
  const queryParams = useSearchParams();
  const clientHasRendered = useClientHasRendered();

  return clientHasRendered &&
    queryParams &&
    queryParams.has(URLParameters.Company) &&
    queryParams.get(URLParameters.Flow) ? (
    <DynamicOnboarding />
  ) : (
    <></>
  );
};
